import React from "react";

function Canvas_Rectangles() {
  return (
    <div>
      <h1>Canvas_Rectangles Component</h1>
      <p>This is the Canvas Rectangles tutorial page content.</p>
    </div>
  );
}

export default Canvas_Rectangles;
